module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent-t"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bandit Mentality")]), _vm._v(" captures Lindsay ‘Kiwi’ O’Brien’s Bush War service from 1976-1980 at the coalface of the Rhodesian conflict. Starting in the BSA Police Support Unit – the police force’s professional anti-terrorist battalion – he served across the country as a section leader and a troop commander before joining the UANC’s political armies as a trainer and advisor.")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Much has been written about the army’s elite units, but Support Unit’s war record was mainly unknown during the conflict and has faded into obscurity afterwards. Support Unit started poorly supplied and equipped, but the caliber of the men – mostly African – was second to none. Support Unit specialized in the ‘grunt’ work inside Rhodesia, with none of the flamboyant helicopter or cross-border raids carried out by the army. O’Brien’s war was primarily within selected tribal lands – seeking out and destroying terrorist units in brisk, close-range battles with little to no support.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("O’Brien moved from the police to working with the initial UANC deployment in the Zambezi Valley, where the poorly trained recruits were delivered into the terrorist lair; they had to learn fast or die. His account is a foreign-born perspective from a junior commander uninterested in promotion and the wrangling of Upper Command. O’Brien was decorated and wounded three times.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a474950","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Bandit.vue
// module id = 57
// module chunks = 0